import * as api from '../services/taxes';
import {getTaxesSuccess} from '../reducers/taxesReducer';
import {getSummarySuccess, setFetching, getSummaryFail} from '../reducers/summaryReducer';
import {getCurrentDeliveryMasterCalcAddress} from "../selectors/address";
import { ticketCalcDataReceieved } from '../reducers/cartReducer';
import { getCurrentTicketType } from '../selectors/configSelectors';
import { showModal, hideModal } from '../reducers/overlayingModalReducer';
import { goBack } from 'connected-react-router';
import { guessPackageCustomerType } from '../helpers/customer_type_helper';

export function startGetTaxes() {
  return dispatch => {
    api.getTaxes().then(
      response => {
        dispatch(getTaxesSuccess(response.data.data));
      },
      error => console.log(error)
    );
  };
}

export function startClearTaxes() {
  return dispatch => {
    api.clearTaxes().then(
      response => {
        dispatch(getTaxesSuccess(response.data.data));
      },
      error => console.log(error)
    );
  };
}

export function startGetSummary(masterCalcReq, payByPoints, onError) {
  return (dispatch, getState) => {
    const state = getState();

    const data = {
      ticketItems: masterCalcReq.ticketItems.map(ti => ({
        ...ti,
        customerType: guessPackageCustomerType(state, ti.customerType),
      })),
      delivery: masterCalcReq.isDelivery,
      ticketDiscounts: payByPoints >= 0 
        ? [{
          discountNumericType: 2,
          title: `Rewards Redemption`,
          method: 'DOLLAR',
          stackable: true,
          rewardable: true,
          restaurantId: 1,
          currentFlag: true,
          amount: payByPoints,
          adjustment: false,
          isPos: true,
          isCart: true,
          discountRules: [{
            ruleCategory: "POS",
            ruleName: "IS_CART",
            ruleValue: "true",
          }]
        }]
        : []
    };

    if (data.delivery) {
      data.deliveryAddress = getCurrentDeliveryMasterCalcAddress(state);
    }
    
    return api.getSummary(data, getCurrentTicketType(state)).then(
      (response) => {
        dispatch(setFetching(false));

        if (!response || !response.data.data) {
          dispatch(getSummaryFail());

          if (onError) {
            onError();
          }

          return;
        }

        dispatch(getSummarySuccess(response.data.data));
        dispatch(ticketCalcDataReceieved());
      },
      error => console.log(error),
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/taxes.js